/* global G */
import { curry } from 'lib/util'

/**
 * With Term Event Handler
 *
 * Ensures that `component` has a term set in its `[G.STATE][G.META]`.
 * If not, the search will not be performed and instead, `[]` is
 * returned.
 *
 * @param {Function} fn                     search handler to execute
 * @param {Gaia.AppModule.Spec} module      app module
 * @param {Gaia.AppModule.Action} component action component
 * @param {PlatformEvent} event             the event that triggered this handler
 * @returns {Object[]}
 */
const withTerm = (fn, module, component, event) => {
  const { term = null } = component?.[G.STATE]?.[G.META] || {}

  return term || event?.detail?.term || event?.term
    ? fn(module, component, event)
    : []
}

export default curry(withTerm)
